import activity from './device_group_stat/activity';
import battery from './device_group_stat/battery';
import chart from './device_group_stat/chart';
import dataStat from './device_group_stat/data_stat';

export default {
  namespaced: true,
  modules: { activity, battery, chart, dataStat }
};
